(() => {
  if (window.beltboxDirectCheckoutBound) return;
  window.beltboxDirectCheckoutBound = true;

  window.addEventListener(
    'click',
    (event) => {
      const clickedButton = event.target instanceof Element
        ? event.target.closest('#CartDrawer-Checkout')
        : null;

      if (!clickedButton || clickedButton.dataset.beltboxDirectCheckout !== 'true') return;

      const termsCheckbox = document.querySelector('[id^="TNC-Checkbox-"]');
      if (termsCheckbox && termsCheckbox.dataset.checked !== 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      clickedButton.classList.add('loading');
      const spinner = clickedButton.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      window.location.assign('/checkout');

      window.setTimeout(() => {
        if (window.location.pathname.includes('/checkout')) return;
        clickedButton.classList.remove('loading');
        clickedButton.disabled = false;
        if (spinner) spinner.classList.add('hidden');
      }, 8000);
    },
    true
  );
})();
